import VueRouter from 'vue-router';

import { PortalUser } from './api';
import Login from './components/Login';

import IndicatorList from './components/indicators/IndicatorList';
import Indicator from './components/indicators/Indicator';
import IndicatorDetails from './components/indicators/IndicatorDetail';
import CreateIndicator from './components/indicators/CreateIndicator';

import UserList from './components/user/UserList';
import User from './components/user/User';
// import UserDetails from './components/user/Details';
import UserDetails from './components/user/UserDetail';

import MeaList from './components/mea/MeaList';
import MEA from './components/mea/MEA';
import MeaDetail from './components/mea/MeaDetail';
import CreateMea from './components/mea/CreateMea';

import TagList from './components/tag/TagList';
import Tag from './components/tag/Tag';
import TagDetail from './components/tag/TagDetail';
import CreateTag from './components/tag/CreateTag';

import ReportList from './components/report/ReportList';
import TestReportList from './components/report/TestReportList';
import Report from './components/report/Report';
import ReportCreationWizard from './components/report/ReportCreationWizard';
import Leaflet from './components/report/Leaflet';
import ChartDisplay from './components/report/ChartDisplay';
import ReportContainer from './components/report/ReportContainer';

// organizaiton component properties
import Organization from './components/organization/Organization';
import OrganizationList from './components/organization/OrganizationList';
import OrganizationDetail from './components/organization/OrganizationDetail';
import OrganizationCreate from './components/organization/OrganizationCreate';

// groups component properties
import Group from './components/group/Group';
import GroupList from './components/group/GroupList';
import GroupDetail from './components/group/GroupDetail';
import GroupCreate from './components/group/GroupCreate';

// roles component properties
import Role from './components/role/Role';
import RoleList from './components/role/RoleList';
import RoleDetail from './components/role/RoleDetail';
import RoleCreate from './components/role/RoleCreate';


import FrontPage from './components/FrontPage';

// mou component properties
import MOU from './components/mou/MOU';
import MouList from './components/mou/MouList';
import MouDetail from './components/mou/MouDetail';
import MouCreate from './components/mou/MouCreate';

// reminder component properties
import ReminderList from './components/reminder/ReminderList';
import Reminder from './components/reminder/Reminder';
import ReminderDetail from './components/reminder/ReminderDetail';


import InviteUser from './components/user/InviteUser';
import ResetUsersPassword from './components/user/ResetPassword';

import DataSourceList from './components/dataSource/DataSourceList';
import TestDataSourceList from './components/dataSource/TestDataSourceList';
import DataSource from './components/dataSource/DataSource';
import DataSourceDetails from './components/dataSource/Details';
import CreateDataSource from './components/dataSource/CreateDataSource';

import Profile from './components/profile/Profile';


import Dashboard from './components/Dashboard';
import Forbidden from './components/Forbidden';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import DashboardContent from './components/DashboardContent';
import Settings from './components/Settings';
import store from './store';


function logOut (to, from, next){
  PortalUser.logOut();
  next("/login");
}


const dashboard_routes = [
    {
        path: '/reports',
        component: DashboardContent,
        meta: {
            requiresPerm: 'view_report',
            icon: 'icon-report',
            name: 'Reports'
        },
        children: [
            {
                name: 'List Reports',
                path: '',
                component: ReportList,
                meta: { requiresPerm: 'view_report' } 
            },
            {
                name: 'Test List Reports',
                path: 'list-test',
                component: TestDataSourceList,
                meta: { requiresPerm: 'view_report' }
            }, 
            {
                name: 'Create Report',
                path: 'create',
                component: ReportCreationWizard,
                meta: { requiresPerm: 'add_report'}
            },
            {
                name: 'Report Details',
                path: ':id/details',
                component: ReportContainer,
                meta: { requiresPerm: 'view_report'}
            },
        ]
    },
    {
        path: '/meas',
        component: DashboardContent,
        meta: {
            requiresPerm: 'view_mea',
            icon: 'icon-mea',
            name: 'MEAs'
        },
        children: [
            {
                name:'List MEA',
                path: '',
                component: MeaList,
                meta: { requiresPerm: 'view_mea'}
            },
            {
                name:'Create MEA',
                path: 'create',
                component: CreateMea,
                meta: { requiresPerm: 'add_mea'}
            },
            {
                name: 'MEA Details',
                path: ':id/details',
                component: MeaDetail,
                meta: { requiresPerm: 'view_mea'}
            }
        ]
    },
    {
        path: '/indicators',
        component: DashboardContent,
        meta: {
            requiresPerm: 'view_indicator',
            icon: 'icon-indicators',
            name: 'Indicators'
        },
        children: [
            {
                name: 'List Indicators',
                path: '',
                component: IndicatorList,
                meta: { requiresPerm: 'view_indicator'}
            },
            {
                name: 'Create Indicators',
                path: 'create',
                component: CreateIndicator,
                meta: { requiresPerm: 'add_indicator'}
            },
            {
              name: 'Indicators Detail',
              path: ':id/details',
              component: IndicatorDetails,
              meta: { requiresPerm: 'view_indicator'}
            },
            {
              path: '*',
              redirect: { path: '/', }
            },
        ]
    },
    {
        path: '/data-sources',
        component: DashboardContent,
        meta: {
            requiresPerm: 'view_datasource',
            icon: 'icon-rate-guide',
            name: 'Data Sources'
        },
        children: [
            {
                name: 'List Data Sources',
                path: '',
                component: DataSourceList,
                meta: { requiresPerm: 'view_datasource'}
            },
            {
                name: 'Create Data Sources',
                path: 'create',
                component: CreateDataSource,
                meta: { requiresPerm: 'add_datasource'}
            },
            {
                path: ':id/details',
                component: DataSourceDetails,
                meta: { requiresPerm: 'view_datasource'}
            }
        ]
    },

    {
        path: '/reminders',
        component: DashboardContent,
        meta: {
            requiresPerm: 'view_reminder',
            icon: 'icon-notifications',
            name: 'Reminders'
        },
        children: [
            {
                name: 'List Reminders',
                path: '',
                component: ReminderList,
                meta: { requiresPerm: 'view_reminder'}
            },
            // {
            //     name: 'Create Reminders',
            //     path: 'create',
            //     component: Reminder,
            //     meta: { requiresPerm: 'add_reminder'}
            // },
            {
                name: 'Reminder Details',
                path: ':id/details',
                component: ReminderDetail,
                meta: { requiresPerm: 'view_reminder'}
            },
        ]
    },



    {
        path: '/organizations',
        component: DashboardContent,
        meta: {
            requiresPerm: 'view_organization',
            icon: 'icon-organization',
            name: 'Organizations'
        },
        children: [
            {
                name: 'List Organizations',
                path: '',
                component: OrganizationList,
                meta: { requiresPerm: 'view_organization'}
            },
            {
                name: 'Create Organization',
                path: 'create',
                component: OrganizationCreate,
                meta: { requiresPerm: 'add_organization'}
            },
            {
                name: 'Organization Detail',
                path: ':id/details',
                component: OrganizationDetail,
                meta: { requiresPerm: 'view_organization'}
            }
        ]
    },
    {
        path: '/users',
        component: DashboardContent,
        meta: {
            requiresPerm: 'view_user',
            icon: 'icon-customers',
            name: 'Users'
        },
        children: [
            {
                name: 'List Users',
                path: '',
                component: UserList,
                meta: { requiresPerm: 'view_user'}
            },
            {
                name: 'Invite User',
                path: 'invite-user',
                component: InviteUser,
                meta: { requiresPerm: 'invite_user'}
            },
            {
                name: 'User Details',
                path: ':id/details',
                component: UserDetails,
                meta: { requiresPerm: 'view_user'}
            },
            {
                name: 'Reset Password',
                path: 'reset-for-user',
                component: ResetUsersPassword,
                meta: { requiresPerm: 'view_user' }
                //meta: { requiresPerm: 'reset_password_user' }
            } 
        ]
    },
    {
        path: '/groups',
        component: DashboardContent,
        meta: {
            requiresPerm: 'view_group',
            icon: 'icon-group',
            name: 'Groups'
        },
        children: [
            {
                name: 'List Groups',
                path: '',
                component: GroupList,
                meta: { requiresPerm: 'view_group'}
            },
            {
              name: 'Create Group',
              path: 'create',
              component: GroupCreate,
              meta: { requiresPerm: 'add_group'}
            },
            {
                name: 'Group Details',
                path: ':id/details',
                component: GroupDetail,
                meta: { requiresPerm: 'view_group'}
            },
        ]
    },

    
    // {
    //     path: '/mous',
    //     component: DashboardContent,
    //     meta: {
    //         requiresPerm: 'view_mou',
    //         icon: 'icon-mou',
    //         name: 'MOUs'
    //     },
    //     children:[
    //         {
    //             name:'List MOU',
    //             path: '',
    //             component: MouList,
    //             meta: { requiresPerm: 'view_mou'}
    //         },
    //         {
    //             name:'Create MOU',
    //             path: 'create',
    //             component: MouCreate,
    //             meta: { requiresPerm: 'add_mou'}
    //         },
    //         {
    //             name:'View MOU',
    //             path: '/mous/:id',
    //             path: ':id/details',
    //             component: MouDetail,
    //             meta: { requiresPerm: 'view_mou'}
    //         }
    //     ]
    // },
    {
        path: '/roles',
        component: DashboardContent,
        meta: {
            requiresPerm: 'view_role',
            icon: 'icon-role',
            name: 'Roles'
        },
        children: [
            {
                name: 'List Roles',
                path: '',
                component: RoleList,
                meta: { requiresPerm: 'view_role'}
            },
            {
                name: 'Create Role',
                path: 'create',
                component: RoleCreate,
                meta: { requiresPerm: 'add_role'}
            },
            {
                name: 'View Role',
                path: ':id/details',
                component: RoleDetail,
                meta: { requiresPerm: 'view_role'}

             },
        ]
    },
    

    
    {
        path: '/profile',
        component: DashboardContent,
        meta: {
            icon: 'icon-profile',
            name: 'Profile',
            requiresPerm: 'auth'
        },
        children: [
            {
                name: 'User Profile',
                path: '',
                component: Profile,
                meta: { requiresPerm: 'auth'}

            }
        ]
    }
];


const routes = [
  { path: '/login', name: 'login', component: Login },
  { path: '/forgot-password', name: 'Forgot Password', component: ForgotPassword },
  { path: '/reset-password/:uid/:token/', name: 'Reset Password', component: ResetPassword },
  { path: '/logout', beforeEnter: logOut },
  { path: '/forbidden', component: Forbidden },
  { path: '/', name: 'front-page', component: FrontPage },
  {
    path: '/',
    component: Dashboard,
    children: dashboard_routes,
  },
  { path: '*', redirect: '/' }
];

export default { routes, mode: 'history', hash: false };
export { dashboard_routes };



// WEBPACK FOOTER //
// ./src/routes.js